import { Button } from '@workspace/ui/components/Button';
import { useBreakpoint } from '@workspace/ui/hooks/useBreakpoint';
import { cn } from '@workspace/ui/lib/utils';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import Icon from '~/components/Icon/Icon';
import { deliveryAddressStore } from '~/components/ModalDeliveryAddress/DeliveryAddressStore';
import { useGeolocation } from '~/hooks/useGeolocation';
import { orderStore } from '~/stores';

interface LocateMeButtonProps
  extends Omit<
    React.ComponentPropsWithoutRef<typeof Button>,
    'children' | 'size' | 'disabled' | 'onClick'
  > {
  hasText?: boolean;
}

export const LocateMeButton = observer(
  ({ hasText = true, className, ...props }: LocateMeButtonProps) => {
    const { t } = useTranslation();
    const { requestLocation } = useGeolocation();
    const { isMobile } = useBreakpoint();

    return (
      <Button
        {...props}
        className={cn(className, 'bg-bg-base shadow-none')}
        variant="outlined"
        size={isMobile ? 'lg' : 'xl'}
        disabled={
          deliveryAddressStore.isAwaitGeolocation ||
          deliveryAddressStore.isLoading ||
          orderStore.isETALoading
        }
        onClick={requestLocation}
        startIcon={<Icon type="geolocation" size={24} />}
      >
        {deliveryAddressStore.isAwaitGeolocation ||
        deliveryAddressStore.isLoading ||
        orderStore.isETALoading ? (
          <span className="spinner _white" />
        ) : hasText ? (
          t('checkout:address:locateMe')
        ) : undefined}
      </Button>
    );
  },
);
LocateMeButton.displayName = 'LocateMeButton';
